import React from "react";
import { Box } from "rebass/styled-components";

export default function Headline(props) {
  return (
    <Box variant="text.headline" {...props}>
      {props.children}
    </Box>
  );
}
